export default "/images/chevron-double-down.svg?4971e4069244affebbb79472f51679cd";